import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllProfilesTotal = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<number>((state, action) => {
    state.allProfiles.total = action.payload;
    state.allProfiles.loadingTotal = false;
  });
